import { render, staticRenderFns } from "./ActuatorForm.vue?vue&type=template&id=d2c01e60&scoped=true&"
import script from "./ActuatorForm.vue?vue&type=script&lang=js&"
export * from "./ActuatorForm.vue?vue&type=script&lang=js&"
import style0 from "./ActuatorForm.vue?vue&type=style&index=0&id=d2c01e60&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2c01e60",
  null
  
)

export default component.exports